module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "crmFmAgentDetails",
    attrs: {
      "close-on-click-modal": false,
      "title": "",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', [_c('base-info-form', {
    ref: "baseInfo",
    attrs: {
      "value": _vm.baseInfo,
      "isReadOnly": true,
      "isComShow": true,
      "isShowAgentCode": true
    }
  }), _vm._v(" "), _c('contact-form', {
    ref: "contact",
    attrs: {
      "value": _vm.contact,
      "isReadOnly": true
    }
  }), _vm._v(" "), (_vm.agentList.length > 0) ? _c('div', [_c('h6', {
    staticClass: "ptitle"
  }, [_vm._v("代理信息")]), _vm._v(" "), _vm._l((_vm.agentList), function(agent, index) {
    return _c('agent-info', {
      ref: 'agentInfo' + (index + 1),
      refInFor: true,
      attrs: {
        "value": agent,
        "myIndex": (index + 1),
        "isReadOnly": true,
        "isHideContractNumber": false,
        "isHideAgentLevel": false
      },
      on: {
        "delAgentfn": _vm.delAgentfn
      }
    })
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "margin-bottom": "15px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("我知道了")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5c6db4ec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CRMAgentManage/CRMFormatAgent/crm-form-agent-details.vue
// module id = 1493
// module chunks = 1